<template>
  <div class="data-statistic-container">
    <div class="search-wrap" style="position: relative;">
      <div class="btn-group">
        <div class="btn" :class="topParams.type == 1 ? 'btn-active' : ''" @click="dateChange(1)">昨日</div>
        <div class="btn" :class="topParams.type == 7 ? 'btn-active' : ''" @click="dateChange(7)">近7日</div>
        <div class="btn" :class="topParams.type == 30 ? 'btn-active' : ''" @click="dateChange(30)">近30日</div>
      </div>
      <el-date-picker v-model="searchSelectTime" size="mini" :editable="false" type="daterange" value-format="yyyy-MM-dd"
        range-separator="-" start-placeholder="统计时间" end-placeholder="统计时间" :picker-options="pickerOptions"
        @change="selectTime($event, 1)" clearable style="width: 240px; margin-right: 12px">
      </el-date-picker>
      <span slot="reference" class="tip">统计说明
        <el-tooltip class="item" effect="dark" content="发送相关统计，受时间控件影响。统计所选时间内发送情况及转化情况。" placement="top">
          <i class="el-icon-question"></i>
        </el-tooltip></span>
    </div>
    <div class="card-wrap" v-loading="loadingTop">
      <div class="card-item" v-for="(item, index) in topDataList" :key="index">
        <img :src="item.icon" class="item-icon" alt="" />
        <div class="item-data">
          <div class="data-title">{{ item.text }}</div>
          <div class="data-num" :style="{ color: item.color }">{{ item.value }}</div>
        </div>
      </div>
    </div>
    <div class="echart-container" v-loading="loadingZX" style="height: 367px;padding: 20px;">
      <div v-if="hasZX" id="zheXiangTu" style="width: 100%;height: 100%;"></div>
      <div v-else class="not-data">暂无数据</div>
    </div>
    <div class="bar-chart-area">
      <div class="chat-survey-wrap">
        <div class="head-wrap">
          <span class="title-name">项目发送排行</span>
          <span class="title-more" @click="chatClick('goods')">更多<i class="el-icon-arrow-right"></i></span>
        </div>
        <div v-loading="loadingBar1" class="echart-container">
          <div v-if="hasBar1" id="chat-bar1" style="width: 100%;height: 100%;"></div>
          <div v-else class="not-data">暂无数据</div>
        </div>
      </div>
      <div class="chat-survey-wrap">
        <div class="head-wrap">
          <span class="title-name">活动发送排行</span>
          <span class="title-more" @click="chatClick('act')">更多<i class="el-icon-arrow-right"></i></span>
        </div>
        <div v-loading="loadingBar1" class="echart-container">
          <div v-if="hasBar2" id="chat-bar2" style="width: 100%;height: 100%;"></div>
          <div v-else class="not-data">暂无数据</div>
        </div>
      </div>
    </div>
    <div class="table-filter">
      <el-tag class="tree-input" title="选择员工" :closable="userIdListName && userIdListName.length === 0 ? false : true"
        @close="searchCloseTag" type="medium" effect="plain" @click="clickAddMember()">
        <span v-if="userIdListName.length === 0">选择员工</span>
        <span v-for="(item, index) in userIdListName" :key="index">{{ item.name }}<span
            v-if="index != userIdListName.length - 1">、</span></span>
      </el-tag>
      <el-date-picker v-model="searchSelectTime2" size="mini" :editable="false" type="daterange" value-format="yyyy-MM-dd"
        range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" :picker-options="pickerOptions"
        @change="selectTime($event, 2)" clearable style="width: 240px;">
      </el-date-picker>
    </div>
    <div class="table-data">
      <el-table size="medium" :header-cell-style="{ background: '#eef1f6', color: '#606266' }" ref="singleTable"
        :highlight-current-row="true" :data="tableData" :default-sort="{ prop: 'bindDangAnCount', order: 'descending' }"
        height="450px" style="width: 100%;height:100%;font-size: 13px" v-loading="loadingTable">
        <el-table-column label="序号" width="65" align="center">
          <template slot-scope="scope">
            {{ pageparm.size * (pageparm.currentPage - 1) + (scope.$index + 1) }}
          </template>
        </el-table-column>
        <el-table-column prop="staffName" label="员工姓名" min-width="88" align="center">
        </el-table-column>
        <el-table-column prop="shareOpenNumber" label="发送总次数" min-width="88" align="center">
          <template slot="header">
            发送总次数
            <el-tooltip class="item" effect="dark" content="指商品库中的商品和活动被发送的总次数" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="productSendNumber" label="商品发送次数" min-width="88" align="center">
          <template slot="header">
            商品发送次数
            <el-tooltip class="item" effect="dark" content="指商品库中的商品类被发送的总次数" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="activitySendNumber" label="活动发送次数" min-width="88" align="center">
          <template slot="header">
            活动发送次数
            <el-tooltip class="item" effect="dark" content="指商品库中的活动类链接被发送次数，包括领券活动，包括活动商品" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="productOpenNumber" label="商品打开次数" min-width="88" align="center">
          <template slot="header">
            商品打开次数
            <el-tooltip class="item" effect="dark" content="指商品库中被发送的商品被客户点击的总次数" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="activityOpenNumber" label="活动打开次数" min-width="88" align="center">
          <template slot="header">
            活动打开次数
            <el-tooltip class="item" effect="dark" content="指商品库中被发送的活动和活动商品被客户点击的总次数" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="registerNumber" label="引流新客数量数" min-width="88" align="center">
          <template slot="header">
            引流新客数量数
            <el-tooltip class="item" effect="dark" content="指商品库中被发送的商品和活动带来的新客注册数量" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="orderTotalNumber" label="客户下单数量" min-width="88" align="center">
          <template slot="header">
            客户下单数量
            <el-tooltip class="item" effect="dark" content="客户通过客莱宝发送的商品&活动商品链接下单的数量" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="staff-pagination">
      <el-pagination @current-change="getTableData" @size-change="getTableData" :current-page.sync="tableParams.page"
        :page-size.sync="tableParams.size" layout="total, sizes, prev, pager, next, jumper" :total="total"
        :page-sizes="[20, 50, 100, 200, 500]">
      </el-pagination>
    </div>
    <customerContact ref="customerContact" />
    <StaffTree title="选择成员" ref="tree" :dialogVisibleTree="dialogVisibleTree" :currentSelectMember="currentSelectMember"
      @closeTree="dialogVisibleTree = false" @clickSubmitTree="clickSubmitTree" />

  </div>
</template>

<script>

import {
  statisticDetailApi, productBarStatisticApi, productStatisticApi, sendRankApi
} from "@/api/commodityBoard.js";
import StaffTree from "@/components/staffTree/staffTree.vue";

import customerContact from './components/customerContact.vue'

export default {
  components: {
    StaffTree,
    customerContact,
  },
  data() {
    return {

      loadingTop: false,
      /**头部请求参数 */
      topParams: {
        type: 7,    //标识 1：昨日  7：近七日  30：近30日  【int，非必传,mark与统计时间范围要选择其中一个，如果两者都选按mark为准】
        startTime: "",    //开始时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
        endTime: ""  //结束时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
      },
      // 顶部数据
      topDataList: [
        {
          key: 'totalSendNumber',
          icon: require('@/assets/img/topCount1.png'),
          text: '发送总次数',
          value: 0,
        },
        {
          key: 'shelveSendNumber',
          icon: require('@/assets/img/topCount2.png'),
          text: '商品发送次数',
          value: 0,
        },
        {
          key: 'activitySendNumber',
          icon: require('@/assets/img/topCount3.png'),
          text: '活动发送次数',
          value: 0,
        },
        {
          key: 'customerOpenNumber',
          icon: require('@/assets/img/topCount4.png'),
          text: '客户打开次数',
          value: 0,
        },
        {
          key: 'newCustomerNumber',
          icon: require('@/assets/img/topCount5.png'),
          text: '引流新客户数',
          value: 0,
        },
      ],

      loadingZX: false,
      hasZX: true,

      loadingBar1: false,
      hasBar1: true,
      hasBar2: true,

      /**选择员工弹出框 */
      dialogVisibleTree: false,
      currentSelectMember: [],
      userIdListName: [],
      /**底部表格参数 */
      tableParams: {
        /**员工 */
        userIdList: [],
        /**开始时间 */
        startTime: null,
        /**结束时间 */
        endTime: null,
        page: 1,
        size: 20
      },
      total: 0,
      tableData: [],
      loadingTable: false,



      showCustomBtn: false,
      searchSelectTime: '',
      searchSelectTime2: '',
      btnActive: 7,
      pageparm: {
        currentPage: 1,
        size: 10,
        total: 0,
      },
      avgReplyTimeCount: 0,         //平均首次回复时长
      // 员工排行表格数据
      staffRankData: [],
      pickerOptions: {
        disabledDate: (time) => {
          let curDate = new Date().getTime();
          const day = 180 * 24 * 3600 * 1000;
          return time.getTime() > Date.now() - 8.64e7 || time.getTime() < (curDate - day);
        }
      },
      // 字段设置
      setting: [{
        isSelect: false,
        name: '客户总数1'
      },
      {
        isSelect: true,
        name: '客户总数2'
      },
      {
        isSelect: true,
        name: '客户总数3'
      },
      {
        isSelect: false,
        name: '客户总数4'
      },
      {
        isSelect: true,
        name: '客户总数5'
      },
      {
        isSelect: false,
        name: '客户总数6'
      }]
    }
  },
  mounted() {
    this.getTopData()
    this.getZX()
    this.getBar1()
    this.getTableData()
  },
  methods: {
    /**打开选择员工 */
    clickAddMember() {
      console.log('打开选择员工');
      this.dialogVisibleTree = true;
    },
    /**清空成员 */
    searchCloseTag() {
      this.userIdListName = [];
      this.currentSelectMember = []
      this.tableParams.userIdList = []
      this.tableParams.page = 1
      this.getTableData()
    },
    /**选中员工 */
    clickSubmitTree(val) {
      console.log('clickSubmitTree', val);

      this.currentSelectMember = val.currentMember
      this.tableParams.page = 1;
      this.tableParams.userIdList = []
      this.userIdListName = val.currentIdName
      val.sendArray.forEach(item => {
        this.tableParams.userIdList.push(item.userId)
      })
      this.dialogVisibleTree = false;
      this.getTableData()

      // this.tableParams.userIdList = [];
      // this.userIdListName=[]

      // val.sendArray.forEach(v=>{
      //   this.userIdListName.push(v.userName)
      // })
      // let arr = JSON.parse(JSON.stringify(val.sendArray))
      // arr.forEach(item => {
      //   this.tableParams.userIdList.push(item.userId)
      // })
      // this.dialogVisibleTree = false;
      // this.getTableData()
    },
    /**获取表格数据 */
    getTableData() {
      this.loadingTable = true
      statisticDetailApi(this.tableParams, localStorage.getItem("Authorization")).then((res) => {
        this.loadingTable = false
        console.log('获取表格数据', res, this.tableParams);
        if (res.error.code == 200 && res.data.records) {
          this.tableData = res.data.records
          this.total = Number(res.data.total || 0)
        } else {
          this.tableData = []
          this.total = 0
        }
      }).catch(() => {
        this.loadingTable = false
      });
    },
    chatClick(tab) {
      this.$nextTick(() => {
        this.$refs.customerContact.show(tab)
      })
    },
    callBack(parm) {
      this.tableParams.page = parm.currentPage;
      this.tableParams.size = parm.pageSize;
      console.log('callBack---', parm);
      this.getTableData()
    },
    // 选择时间处理
    selectTime(dataTime, type) {
      console.log('选择时间处理----', dataTime, type);
      switch (type) {
        case 1:
          // 统计时间
          if (dataTime) {
            this.topParams.startTime = new Date(dataTime[0]).getTime()
            this.topParams.endTime = new Date(dataTime[1]).getTime()
            this.topParams.type = null
          } else {
            this.topParams.startTime = null
            this.topParams.endTime = null
            this.topParams.type = 7
          }
          this.getTopData()
          this.getZX()
          this.getBar1()
          break;
        case 2:
          // 表格开始结束时间
          if (dataTime) {
            this.tableParams.startTime = new Date(dataTime[0]).getTime()
            this.tableParams.endTime = new Date(dataTime[1]).getTime()
          } else {
            this.tableParams.startTime = null
            this.tableParams.endTime = null
          }
          this.tableParams.page = 1
          this.getTableData()
          break;
        default:
          break;
      }
    },
    // 选择昨日/近7天/近一个月 val=1时为昨日。val=2时为近7天。val=3时为近一个月
    dateChange(val) {
      this.topParams.type = val
      this.searchSelectTime = ''
      this.topParams.startTime = ''
      this.topParams.endTime = ''
      this.getTopData()
      this.getZX()
      this.getBar1()
    },
    /**获取头部模块数据 */
    getTopData() {
      this.loadingTop = true
      productBarStatisticApi(this.topParams, localStorage.getItem("Authorization")).then(res => {
        this.loadingTop = false
        if (res.error.code == 200 && res.data) {
          this.topDataList.forEach(v => {
            if (v.key in res.data) {
              v.value = res.data[v.key]
            }
          })
        }
      }).catch((err) => {
        this.loadingTop = false
        this.$message.error('获取数据失败，请重试！')
      })
    },
    /**获取折线图 */
    getZX() {
      // this.loadingZX = true
      // this.hasZX = true
      // productStatisticApi(this.topParams, localStorage.getItem("Authorization")).then(res => {
      //   this.loadingZX = false
      //   if (res.error.code == 200 && res.data) {
      //     // 后端xx说x轴都是一样的  不用处理
      //     let Xdata = []
      //     const X1data = []
      //     const X2data = []
      //     const X3data = []
      //     const Y1data = []
      //     const Y2data = []
      //     const Y3data = []
      //     // 注册
      //     if (res.data.registerNumber) {
      //       res.data.registerNumber.forEach(v => {
      //         X1data.push(v.sendTime)
      //         Y1data.push(v.shareNumber)
      //       })
      //     }
      //     // 打开次数
      //     if (res.data.openNumber) {
      //       res.data.openNumber.forEach(v => {
      //         X2data.push(v.sendTime)
      //         Y2data.push(v.shareNumber)
      //       })
      //     }
      //     // 发送次数
      //     if (res.data.sendNumber) {
      //       res.data.sendNumber.forEach(v => {
      //         X3data.push(v.sendTime)
      //         Y3data.push(v.shareNumber)
      //       })
      //     }
      //     Xdata = X1data || X2data || X3data
      //     if(Xdata&&(Y1data.length||Y2data.length||Y3data.length)){
      //       this.$nextTick(() => {
      //         this.changetype(Xdata, Y1data, Y2data, Y3data)
      //       })
      //     }else{
      //     this.hasZX = false
      //     }
      //   } else {
      //     this.hasZX = false
      //   }
      // }).catch((err) => {
      //   this.loadingZX = false
      //   this.hasZX = false
      //   this.$message.error('获取折线图数据失败，请重试！')
      // })
    },

    /**渲染折线图 */
    changetype(xAxisData, Y1data, Y2data, Y3data,) {
      console.log('渲染折线图', xAxisData, Y1data, Y2data, Y3data)
      // 获取组件实例
      let machart = this.$echarts.getInstanceByDom(document.getElementById("zheXiangTu"))
      if (machart == null) {
        machart = this.$echarts.init(document.getElementById("zheXiangTu"))
      }

      var option = {
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "2%",
          containLabel: true
        },

        legend: {
          data: ["新客注册数", "打开次数", "发送次数"]
        },
        color: ['#2684FF', '#00A870'],
        xAxis: {                //设置x轴
          type: 'category',
          boundaryGap: false,     //坐标轴两边不留白
          data: xAxisData,
          axisLine: {             //坐标轴轴线相关设置。
            show: false,
            lineStyle: {
              color: '#CCCCCC',
            }
          },
          axisLabel: {
            textStyle: {
              color: 'rgba(0, 0, 0, 0.9)',  //坐标的字体颜色
            },
            margin: 15
          },
        },
        yAxis: {
          axisLine: {
            lineStyle: {
              color: '#FA6F53',
            }
          },
          splitLine: {    //网格线
            lineStyle: {
              type: 'dashed'    //设置网格线类型 dotted：虚线   solid:实线
            },
            show: true //隐藏或显示
          },
          axisLabel: {
            textStyle: {
              color: 'rgba(0, 0, 0, 0.9)',  //坐标的字体颜色
            },
          },
          type: 'value'
        },
        series: [
          {
            name: '新客注册数',
            data: Y1data,
            smooth: true,
            type: 'line',               // 类型为折线图
            symbolSize: 5,              //拐点大小
            itemStyle: {
              color: '#2684FF',//拐点颜色
              borderColor: '#2684FF',//拐点边框颜色
              borderWidth: 1,//拐点边框大小
              emphasis: {
                color: '#2684FF',//hover拐点颜色定义
                borderWidth: 5//拐点边框大小
              }
            },
            lineStyle: {                // 线条样式 => 必须使用normal属性
              color: '#2684FF',
            },
            animation: false,
          },
          {
            name: '打开次数',
            data: Y2data,
            smooth: true,
            type: 'line',               // 类型为折线图
            symbolSize: 5,              //拐点大小
            itemStyle: {
              color: '#00A870',//拐点颜色
              borderColor: '#00A870',//拐点边框颜色
              borderWidth: 1,//拐点边框大小
              emphasis: {
                color: '#00A870',//hover拐点颜色定义
                borderWidth: 5//拐点边框大小
              }
            },
            lineStyle: {                // 线条样式 => 必须使用normal属性
              color: '#00A870',
            },
            animation: false,
          },
          {
            name: '发送次数',
            data: Y3data,
            smooth: true,
            type: 'line',               // 类型为折线图
            symbolSize: 5,              //拐点大小
            itemStyle: {
              color: '#F3B2B8',//拐点颜色
              borderColor: '#F3B2B8',//拐点边框颜色
              borderWidth: 1,//拐点边框大小
              emphasis: {
                color: '#F3B2B8',//hover拐点颜色定义
                borderWidth: 5//拐点边框大小
              }
            },
            lineStyle: {                // 线条样式 => 必须使用normal属性
              color: '#F3B2B8',
            },
            animation: false,
          }
        ]
      };


      machart.setOption(option);
      // 根据页面大小自动响应图表大小
      window.addEventListener("resize", function () {
        machart.resize();
      });
    },
    /**获取发送排行数据 */
    getBar1() {
      this.loadingBar1 = true
      this.hasBar1 = true
      this.hasBar2 = true
      sendRankApi(this.topParams, localStorage.getItem("Authorization")).then(res => {
        this.loadingBar1 = false
        console.log('获取发送排行数据', res);
        if (res.error.code == 200 && res.data) {
          const X1data = []
          const Y1data = []
          const X2data = []
          const Y2data = []
          // 项目发送
          if (res.data.productList && res.data.productList.length) {
            res.data.productList.forEach(v => {
              X1data.push(v.name)
              Y1data.push(v.shareNumber)
            })
          }
          // 活动发送
          if (res.data.activityList && res.data.activityList.length) {
            res.data.activityList.forEach(v => {
              X2data.push(v.name)
              Y2data.push(v.shareNumber)
            })
          }
          this.$nextTick(() => {
            X1data && X1data.length ? this.changeBartype(X1data, Y1data, 'chat-bar1') : this.hasBar1 = false
            X2data && X2data.length ? this.changeBartype(X2data, Y2data, 'chat-bar2') : this.hasBar2 = false
          })
        } else {
          this.hasBar1 = false
          this.hasBar2 = false
        }
      }).catch((err) => {
        this.loadingBar1 = false
        this.hasBar1 = false
        this.hasBar2 = false
        this.$message.error('获取发送排行数据失败，请重试！')
      })
    },

    /**渲染柱状图 */
    changeBartype(Xdata, Ydata, id) {
      console.log('渲染柱状图', Xdata, Ydata, id)
      // 获取组件实例
      let machart = this.$echarts.getInstanceByDom(document.getElementById(id))
      if (machart == null) {
        machart = this.$echarts.init(document.getElementById(id))
      }
      console.log('渲染柱状图---', machart);
      var option = {

        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "1%",
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: Xdata,
          nameTextStyle: {
            color: '#333', // 字体颜色
            fontSize: 16, // 字体大小
            fontWeight: 'bold', // 字体粗细
            align: 'center', // 文本对齐方式，'left', 'right', 'center'
            padding: [5, 0, 0, 0] // 文字与轴线之间的距离
          },
          axisLabel: {
            interval: 0, // 控制标签的显示间隔，0 表示全部显示
            margin: 20,  // 控制标签与轴线的距离，增加这个值可以避免遮挡
            show: true,
            rotate: 35,//35度角倾斜显示
            formatter: function (params) {
              var str = "";                 // 最终拼接成的字符串
              var paramsLen = params.length;// 获取每项文字的个数
              var len = 17;                  // 每行能显示的字的个数（根据实际情况自己设置）
              var rowNumber = Math.ceil(paramsLen / len); // 换行的话，需要显示几行，向上取整
              if (paramsLen > len) {        //大于设定的len就换行，不大于就不变化
                for (var i = 0; i < rowNumber; i++) {
                  var temp = "";            // 表示每一次截取的字符串
                  var start = i * len;      // 开始截取的位置
                  var end = start + len;    // 结束截取的位置
                  if (i == rowNumber - 1) { // 最后一次不换行
                    temp = params.substring(start, paramsLen);
                  } else {                  // 每一次拼接字符串并换行
                    temp = params.substring(start, end) + "\n";
                  }
                  str += temp;              // 最终拼成的字符串
                }
              } else {                      // 给新的字符串赋值
                str = params;
              }


              if (str.length > 34) {
                str = str.slice(0, 34) + '...';
              }
              return str;                   //返回字符串
            }
          },
        },
        yAxis: {
          type: 'value'
        },
        series: [

          {
            data: Ydata,
            type: 'bar',
            stack: 'Total',
            label: {
              show: true,
              position: 'top'
            },
          }
        ]
      };
      machart.setOption(option);
      // 根据页面大小自动响应图表大小
      window.addEventListener("resize", function () {
        machart.resize();
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.data-statistic-container {
  height: calc(100% + 30px);
  width: calc(100% + 38px);
  // padding-right: 10px;
  margin-top: -15px;
  margin-left: -19px;
  overflow: auto;
  box-sizing: border-box;
  background-color: rgb(244, 247, 252);
}

.search-wrap {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-bottom: 16px;

  .btn-group {
    margin-right: 12px;
    display: flex;
    align-items: center;
    background-color: white;
    cursor: pointer;
    border-radius: 4px;

    .btn {
      padding: 5px 16px;
      border: 1px solid #E6E9EB;

      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        border-right: none;
      }

      &:not(:first-child):not(:last-child) {
        border-radius: 0;
        border-right: none;
      }

      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }

      &:hover {
        color: #409EFF;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
      }
    }

    .btn-active {
      color: white;
      border-color: #4080F9;
      background-color: #4080F9;

      &:hover {
        color: white;
        border-color: #4080F9;
        background-color: #4080F9;
      }
    }
  }

  .tip {
    color: rgba(0, 0, 0, 0.6);
    cursor: pointer;
  }

  .popover {
    border: 1px solid #2684FF;
    position: absolute;
    top: 1px;
    right: 20px;
  }

}

.list {
  z-index: -10;

  .item {
    border: 1px solid #fff;
    float: left;
    width: 80px;
    margin: 5px 3px;
    text-align: center;
    font-size: 13px;
    background: #eeeeee;
    padding: 2px 0;
    cursor: pointer;
  }

  .active {
    background: #d7eaff;
    color: #1a70c9;
    border-color: #409eff;
  }
}

.card-wrap {
  display: grid;
  grid-template-columns: repeat(5, minmax(227px, auto));
  grid-gap: 16px;
  margin-bottom: 16px;

  .card-item {
    background-color: white;
    height: 80px;
    padding: 16px 24px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    box-sizing: border-box;

    .item-icon {
      width: 40px;
      height: 40px;
      margin-right: 12px;
    }

    .item-data {
      flex: 1;
      overflow: hidden;

      .data-title {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: rgba(0, 0, 0, 0.6);
        margin-bottom: 4px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
      }

      .data-num {
        font-weight: 500;
        font-size: 20px;
        line-height: 22px;
        color: rgba(0, 0, 0, 0.9);

        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
      }
    }
  }
}


.echart-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  background-color: #fff;

  .not-data {
    text-align: center;
    font-size: 14px;
    color: #7f7f7f;
  }
}

// 柱状图
.bar-chart-area {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  gap: 16px;

  .chat-survey-wrap {
    width: 50%;
    flex: 1;
    background-color: white;
    padding: 20px 24px 0 24px;
    height: 485px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    .head-wrap {
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;

      span {
        display: block;

        &:first-child {
          color: rgba(0, 0, 0, 0.9);
          font-weight: bold;
          margin-right: 16px;
          font-size: 14px;
        }

        &:last-child {
          color: #2684FF;
          font-size: 14px;
          cursor: pointer;
        }
      }

      .chat-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        margin-bottom: 22px;

        .title-left {
          cursor: pointer;
          display: flex;
          align-items: center;

          .chat-overview {
            margin-right: 36px;
          }

          .tip {
            color: rgba(0, 0, 0, 0.6);
            cursor: pointer;
            font-size: 12px;
          }

          .title-name {
            color: rgba(0, 0, 0, 0.9);
            font-weight: bold;
            margin-right: 16px;
          }

          .title-more {
            color: #2684FF;
          }
        }

        .title-right {
          display: flex;
          align-items: center;
          cursor: pointer;

          .title-btn {
            padding: 2px 12px;
            border: 1px solid #E6E9EB;
            font-size: 12px;
            font-weight: bold;
            color: rgba(0, 0, 0, 0.9);

            &:last-child {
              border-left: none;
              border-radius: 0px 2px 2px 0px;
            }

            &:first-child {
              border-radius: 2px 0px 0px 2px;
            }
          }

          .btn-activ {
            color: #2684FF;
            background: rgba(64, 128, 249, 0.2);
            border-left: 1px solid !important;
            border-color: #2684FF;
          }
        }
      }

      .chat-body {
        display: flex;
        align-items: center;

        .body-li {
          display: flex;
          flex-direction: column;
          margin-right: 32px;
          background: #F1F3F5;
          border-radius: 2px;
          padding: 5px 12px;

          .li-title {
            color: rgba(0, 0, 0, 0.6);
            margin-bottom: 4px;
            font-size: 14px;

            .icon-style {
              margin-left: 5px;
            }
          }

          .li-count-wrap {
            display: flex;
            align-items: center;

            .li-count {
              color: rgba(0, 0, 0, 0.9);
              font-size: 20px;
              font-weight: bold;
            }

            .li-unit {
              font-size: 12px;
              color: rgba(0, 0, 0, 0.6);
              ;
              margin-left: 5px;
            }
          }

        }
      }
    }

    #chat-survey {
      flex: 1;
    }
  }

  .staff-rank-wrap {
    width: 592px;
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    height: 485px;
    background-color: white;
    padding: 20px 24px 24px 24px;

    .head-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
      margin-bottom: 16px;

      .tip {
        font-size: 12px;
        color: #7f7f7f;
      }

      .title-name {
        color: rgba(0, 0, 0, 0.9);
        font-weight: bold;
        margin-right: 16px;
      }

      .title-more {
        color: #2684FF;
      }
    }


  }
}

.table-filter {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 10px;
  margin-top: 20px;

  /deep/.tree-input {
    width: 300px;
    position: relative;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;

    .el-icon-close {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 5px;
    }
  }

  .el-tag--plain {
    border-color: #DCDFE6;
    color: #C0C4CF;
  }
}

// 表格

.table-data {
  margin-bottom: 18px;

  /deep/.el-table {
    display: flex;
    flex-direction: column;

    .el-table__body-wrapper {
      flex: 1 !important;
    }
  }

  /deep/.el-table__row .cell {
    padding: 10px 12px;
  }

  /deep/.el-table--medium th {
    padding: 10px 0;
  }

  /deep/ .el-table--medium td {
    padding: 0;
  }
}

.staff-pagination {
  display: flex;
  justify-content: flex-end;
}





// 表格排序图标
/deep/ .el-table {
  .caret-wrapper {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    height: 22px;
    width: 24px;
    vertical-align: middle;
    cursor: pointer;
    overflow: initial;
    position: relative;

    .sort-caret {
      width: 0;
      height: 0;
      border: 3px solid transparent;
      position: absolute;
      left: 3px;
    }

    .ascending {
      border-bottom-color: #C0C4CC;
      top: 2px;
    }

    .descending {
      border-top-color: #C0C4CC;
      bottom: 5px;
    }
  }

  .descending .sort-caret.descending {
    border-top-color: #409EFF;
  }

  .ascending .sort-caret.ascending {
    border-bottom-color: #409EFF;
  }
}
</style>